import { Scissors } from "lucide-react";

export const ModClipAlert = ({ a, en }) => (
  <div className="absolute top-10 left-1/2 -translate-x-1/2 cx-modclip" data-testid="overlay-modclip-alert">
    <div className="cx-modclip-card relative flex items-center gap-5 rounded-2xl px-8 py-5 bg-[#07060f]/85 border-2 border-[#ff2bd6]">
      <div className="cx-modclip-icon w-16 h-16 rounded-xl grid place-items-center bg-[#ff2bd6]/15 border border-[#3ad7ff]">
        <Scissors className="w-9 h-9 text-[#3ad7ff]" />
      </div>
      <div className="leading-none">
        <div className="cx-modclip-title font-black italic tracking-tight text-6xl text-white" data-testid="overlay-modclip-title">CLIP !</div>
        <div className="mt-2 text-xl font-bold text-[#ff9df0]" data-testid="overlay-modclip-by">
          {en ? "by" : "par"} <span className="text-[#3ad7ff]">@{a.by}</span>
          <span className="ml-3 text-sm font-mono px-2 py-0.5 rounded bg-[#3ad7ff]/15 text-[#3ad7ff] border border-[#3ad7ff]/40" data-testid="overlay-modclip-secs">{a.secs} s</span>
        </div>
      </div>
      <span className="cx-modclip-scan" aria-hidden />
    </div>
  </div>
);
